import { Component, Input, OnInit } from '@angular/core';

@Component( {
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: [ './empty-state.component.scss' ]
} )
export class EmptyStateComponent implements OnInit {

  @Input() label: string = 'Looks like there\'s nothing here!';
  @Input() loading: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }

}
